import { Component, Prop, Event, EventEmitter, h } from '@stencil/core';
import { Color } from '../../interface';

@Component({
  tag: 'range-content',
  styleUrl: 'range.scss',
  shadow: false,
  scoped: true
})
export class RadioButtonContent {
   @Prop() color?: Color;
   @Prop() disabled?: boolean;
   @Prop() value: number;
   @Prop() min: number;
   @Prop() max: number;
   @Prop() step: number;
   @Prop() buttonValue: string;

   @Event() buttonclick!: EventEmitter<number>;

   render() {
    return (
      <div class="center">
      <lar-button
        size="small"
        color={this.color}
        disabled={this.disabled}
        expand="block"
        onClick={() => this.buttonclick.emit()}
      >
        <lar-translate t={this.buttonValue} />
      </lar-button><br />
      <lar-slider
        orientation="vertical"
        disabled={this.disabled}
        value={this.value}
        color={this.color}
        min={this.min}
        step={this.step}
        max={this.max}
      />
      </div>
    );

  }
}